/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// [获取聊天任务的奖励统计信息](https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17568391)
export const getChatMissionStat = createAsyncThunk(
  'ChatCenter/GET_CHAT_MISSION_STAT',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/activity/get_chat_mission_stat', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// https://doc2.ixiaochuan.cn/display/zdxm/2.11.0
export const setChatcenterUserSwitcher = createAsyncThunk(
  'ChatCenter/SET_USER_CHATCENTER_SWITCHER',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/set_user_switcher', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const saveStrategyLetter = createAsyncThunk(
  'ChatCenter/save_strategy_letter',
  async (args: any = {}, store: any) => {
    const resp = await http.post('/live/activity/save_strategy_letter', {
      ...store.getState().env.deviceinfo,
      ...args,
    })
    return resp.data
  }
)

// 申请成为陪聊主播 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92452358
export const apply_sayhi = createAsyncThunk(
  'ChatCenter/apply_sayhi',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/apply_sayhi', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 获取申请状态 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92454662
export const apply_sayhi_homepage = createAsyncThunk(
  'ChatCenter/apply_sayhi_homepage',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/apply_sayhi_homepage', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 陪聊主播通知中心读取某条通知 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92451850
export const read_sayhi_notification = createAsyncThunk(
  'ChatCenter/read_sayhi_notification',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/misc/read_sayhi_notification', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export enum StrategyLetterTypeEnum {
  文字策略信 = 0,
  语音策略信 = 1,
}

export enum APPLY_TYPE {
  applyed = 0, // 已申请置灰
  available = 1, // 可申请
}
export enum RedDotStatus {
  unread = 1,
  read = 2,
}
export interface INotify {
  id: number
  title: string
  content: string
  ct: string
  red_dot: RedDotStatus
}

interface InitialStateType {
  member: {
    avatar: string
    mid: string
    name: string
  }
  // 保级百分比
  maintain: number
  // 当前金币
  coins: number
  // 升级金币
  upgrade_coins: number
  // 金币加成
  coins_addition: number
  // 匹配加成
  match_addition: number
  level: 0 | 1 | 2 | 3
  say_hi: boolean
  show_upgrade_alert: boolean
  level_config: Array<{
    level: 0 | 1 | 2 | 3
    maintain: number
    upgrade: number
    coins_addition: number
    match_addition: number
    c_days?: number // 仅针对level 0 的基础保级天数
  }>
  mission_config: Array<{
    task_reward: number
  }>
  today_data: Array<{
    task: string
    coins: number
    users: number
  }>
  history_data: Array<{
    coins: number
    date: string
  }>
  strategy_letter: string
  kind?: StrategyLetterTypeEnum
  dur?: number
  applyType: APPLY_TYPE
  unread_cnt: number
  unread_notification: INotify
  coins_c: number
  upgrade_coins_c: number
}

const initialState: InitialStateType = {
  member: {
    avatar: '',
    mid: '',
    name: '',
  },
  maintain: 50,
  coins: 0,
  upgrade_coins: 2000,
  coins_addition: 0,
  match_addition: 0,
  level: 0,
  say_hi: false,
  show_upgrade_alert: false,
  level_config: [],
  mission_config: [],
  today_data: [],
  history_data: [],
  // 陪聊优化文案
  strategy_letter: '',
  applyType: APPLY_TYPE.available, // 申请状态
  unread_cnt: 1,
  unread_notification: null,
  coins_c: 0,
  upgrade_coins_c: 0,
}

export const ChatCenterSlice = createSlice({
  name: 'ChatCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChatMissionStat.fulfilled, (state, action) => {
        const {data} = action.payload
        Object.assign(state, data)
      })
      .addCase(setChatcenterUserSwitcher.fulfilled, (state, action) => {
        const {data} = action.payload
        Object.assign(state, {
          say_hi: !!data.value,
        })
      })
      .addCase(apply_sayhi_homepage.fulfilled, (state, action) => {
        const {data} = action.payload
        Object.assign(state, {
          applyType: data.button_typ,
        })
      })
  },
})

export const ChatCenterAction = ChatCenterSlice.actions
export default ChatCenterSlice.reducer
